<template>
  <v-dialog :model-value="isShowDialog"
            max-width="500"
            :persistent="true"
  >
    <v-card class="ma-6 px-2">
      <v-card-text>
        <p><em>We use cookies</em></p>
        <p>We use cookies to enhance your browsing experience, serve personalized ads or content, and analyze our traffic. By check in the below, you consent to our use of cookies.</p>
        <p><em>About terms and conditions</em></p>
        <p>To use this site, you must agree to the terms. Please see the <a href="https://docs.circle.ms/footer/agreement.html">terms and conditions</a> here.</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text"
               color="primary"
               @click="updateConsent(true)"
        >
          Accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getNavigationRoute } from "~/utils/urlHelper";

// 展開時のプロンプト
// src/components/organisms/ServicePolicy.vue は src/content/policy.mdを解釈して表示するページです。現在の help.md の内容を <template> に展開して動的な挙動をなくしてください。 ~/components/atoms/content/*.vue のコンポーネントは展開せず コンポーネント参照 を利用して下さい

const consentCookieName = ".AspNet.Consent"; // Circle.ms ポータルと共通の名称
const setUserConsentCookie = (value: boolean) => useCookie<string>(consentCookieName).value = value ? "yes" : "";
const getUserConsentCookie = () => {
  switch (useCookie<string>(consentCookieName).value?.toLowerCase()) {
    case "yes":
    case "true":
    case "1":
      return true;
    default:
      return false;
  }
};

const cookieConsent = ref(getUserConsentCookie());
const updateConsent = (v: boolean) => {
  cookieConsent.value = v;
  setUserConsentCookie(v);
};

const route = useRoute(); // このコンポーネントは app.vue で NuxtPage と並置 実質 page レベルなので使ってよい
const restrictionRoute = getNavigationRoute("RESTRICTION");
const isShowDialog = computed(() => !cookieConsent.value && route.path !== restrictionRoute);
</script>
